import { Component, OnInit } from '@angular/core';
import { PeopleService } from '../../../../../../shared/services/people.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { CommonModule } from '@angular/common';
import { ConfigurationService } from '../../../../../../shared/services/configuration.service';
import { constants } from '../../../../../../shared/constants/constants';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-bulk-pending-users',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, PaginatorModule,TooltipModule],
  templateUrl: './bulk-pending-users.component.html',
  styleUrl: './bulk-pending-users.component.scss'
})
export class BulkPendingUsersComponent implements OnInit {
  pendingBulkUserList: any[] = [];
  totalRecords: number = 0;
  loading: boolean = false;
  offset: number = 0;
  limit: number = 10;
  isPWCEnabled = false;

  bulkConstants = constants.bulkUserStatus;

  statusOptions = [
    { label: 'Completed', value: this.bulkConstants.published },
    { label: 'In Progress', value: this.bulkConstants.inProgress },
    { label: 'Failed', value: this.bulkConstants.failed }
  ];
  selectedStatus = this.bulkConstants.inProgress;

  constructor(private peopleService: PeopleService, private configurationService: ConfigurationService) {}

  ngOnInit() {
    this.isPWCEnabled = this.configurationService.getPwcFlag();
    this.fetchPendingBulkUsers();
  }

  async fetchPendingBulkUsers(event?: any) {
    this.loading = true;
    if (event) {
      this.offset = event.first || 0;
      this.limit = event.rows || 10;
    }
    try {
        const res = await this.peopleService.getBulkPendingUsers({
            offset: this.offset, 
            limit: this.limit,
            status: this.selectedStatus
        });
        this.pendingBulkUserList = res.pendingBulkUserList || [];
        this.totalRecords = res.count || 0;
        this.loading = false;
    } catch (error) {
        this.pendingBulkUserList = [];
        this.totalRecords = 0;
        this.loading = false;
    }
  }

  onStatusChange() {
    this.offset = 0;
    this.fetchPendingBulkUsers();
  }

  onRefresh() {
    this.offset = 0;
    this.fetchPendingBulkUsers({ first: 0, rows: this.limit });
  }

  fieldExistInObject(field: string): boolean {
    return this.pendingBulkUserList.some(user => {
      const value = user[field];
      // Check if value exists and is not empty/whitespace
      return value != undefined && value != null && String(value).trim() !== '';
    });
  }
}
